import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    // {
    //   id: 1,
    //   name: 'Sarah Johnson',
    //   location: 'New York, NY',
    //   rating: 5,
    //   review: 'Absolutely stunning flowers! The delivery was prompt and the arrangement was even more beautiful than I expected. My mother was overjoyed.',
    //   image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
    //   date: '2 days ago'
    // },
    {
      id: 2,
      name: 'Michael Chen',
      location: 'Los Angeles, CA',
      rating: 5,
      review: 'Perfect service for our anniversary! The roses were fresh and lasted over a week. The personal note was a lovely touch.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      date: '1 week ago'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      location: 'Miami, FL',
      rating: 5,
      review: 'Tulipink made my wedding day even more special. The florist was incredibly professional and the arrangements were breathtaking.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      date: '3 weeks ago'
    },
    {
      id: 4,
      name: 'David Thompson',
      location: 'Chicago, IL',
      rating: 5,
      review: 'Outstanding quality and service. The flowers arrived exactly on time and were packaged beautifully. Highly recommended!',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      date: '5 days ago'
    },
    {
      id: 5,
      name: 'Lisa Wang',
      location: 'Seattle, WA',
      rating: 5,
      review: 'The customer service is exceptional. They helped me choose the perfect arrangement for my friend\'s birthday. Will definitely order again!',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      date: '1 week ago'
    },
    {
      id: 6,
      name: 'James Wilson',
      location: 'Boston, MA',
      rating: 5,
      review: 'Fast delivery and beautiful flowers. The arrangement exceeded my expectations and my wife loved it. Thank you Tulipink!',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      date: '4 days ago'
    }
  ];

  // Auto-rotation effect
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'star--filled' : 'star--empty'}`}>
        ★
      </span>
    ));
  };

  return (
    <section className="testimonials">
      <div className="testimonials__container">
        {/* Header */}
        <div className="testimonials__header">
          <h2 className="testimonials__title">What Our Customers Say</h2>
          <p className="testimonials__subtitle">
            Real stories from real customers who love our flowers
          </p>
        </div>

        {/* Main Testimonial Display */}
        <div className="testimonials__main">
          <div className="testimonial__card">
            <div className="testimonial__content">
              {/* Quote Icon */}
              <div className="testimonial__quote-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/>
                  <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1.005 0 1.005.84 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/>
                </svg>
              </div>

              {/* Review Text */}
              <blockquote className="testimonial__text">
                "{testimonials[currentIndex].review}"
              </blockquote>

              {/* Customer Info */}
              <div className="testimonial__customer">
                <div className="customer__avatar">
                  <img 
                    src={testimonials[currentIndex].image} 
                    alt={testimonials[currentIndex].name}
                    className="customer__image"
                  />
                </div>
                <div className="customer__info">
                  <h3 className="customer__name">{testimonials[currentIndex].name}</h3>
                  <p className="customer__location">{testimonials[currentIndex].location}</p>
                  <div className="customer__rating">
                    {renderStars(testimonials[currentIndex].rating)}
                    <span className="rating__text">Verified Purchase</span>
                  </div>
                </div>
              </div>

              {/* Date */}
              <div className="testimonial__date">
                {testimonials[currentIndex].date}
              </div>
            </div>
          </div>

          {/* Navigation Controls */}
          <div className="testimonials__controls">
            <button 
              className="control__button control__button--prev"
              onClick={prevTestimonial}
              aria-label="Previous testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15,18 9,12 15,6"/>
              </svg>
            </button>
            
            <button 
              className="control__button control__button--next"
              onClick={nextTestimonial}
              aria-label="Next testimonial"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="9,18 15,12 9,6"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Thumbnail Navigation */}
        <div className="testimonials__thumbnails">
          {testimonials.map((testimonial, index) => (
            <button
              key={testimonial.id}
              className={`thumbnail ${index === currentIndex ? 'thumbnail--active' : ''}`}
              onClick={() => goToTestimonial(index)}
              aria-label={`View testimonial from ${testimonial.name}`}
            >
              <img 
                src={testimonial.image} 
                alt={testimonial.name}
                className="thumbnail__image"
              />
              {/* <div className="thumbnail__overlay">
                <div className="thumbnail__rating">
                  {renderStars(testimonial.rating)}
                </div>
              </div> */}
            </button>
          ))}
        </div>

        {/* Auto-play Toggle */}
        {/* <div className="testimonials__autoplay">
          <button 
            className={`autoplay__button ${isAutoPlaying ? 'autoplay__button--active' : ''}`}
            onClick={() => setIsAutoPlaying(!isAutoPlaying)}
            aria-label={isAutoPlaying ? 'Pause auto-rotation' : 'Start auto-rotation'}
          >
            <span className="autoplay__icon">
              {isAutoPlaying ? '⏸️' : '▶️'}
            </span>
            <span className="autoplay__text">
              {isAutoPlaying ? 'Pause' : 'Play'}
            </span>
          </button>
        </div> */}

        {/* CTA Section */}
        {/* <div className="testimonials__cta">
          <button className="cta__button">
            Read More Reviews
            <svg className="cta__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14"/>
              <path d="M12 5l7 7-7 7"/>
            </svg>
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default Testimonials;